import { ToastContext } from '../../context/Toast/ToastContext';
import {
  BOOTSTRAP_ERROR_TOAST,
  CONNECTED_TOAST,
  DISCONNECT_TOAST,
  RECONNECT_TOAST,
} from '../../context/Toast/Toasts';
import { INotificationService } from './INotificationService';

export class ToastNotificationService implements INotificationService {
  constructor(private readonly addToast?: ToastContext['addToast']) {}

  notifyConnected(): void {
    this.addToast?.(CONNECTED_TOAST);
  }

  notifyDisconnected(): void {
    this.addToast?.(DISCONNECT_TOAST);
  }

  notifyReconnecting(): void {
    this.addToast?.(RECONNECT_TOAST);
  }

  notifyBootstrapFailed(): void {
    this.addToast?.(BOOTSTRAP_ERROR_TOAST);
  }
}
